import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col md:flex-row" }
const _hoisted_2 = { class: "hidden md:block bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_3 = { class: "flex justify-end mt-7" }
const _hoisted_4 = { class: "bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_5 = { class: "grid gap-4" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex justify-end mt-7" }
const _hoisted_8 = { class: "flex justify-end items-center md:flex-grow" }
const _hoisted_9 = { class: "flex flex-grow md:hidden" }
const _hoisted_10 = { class: "hidden md:block ml-3" }
const _hoisted_11 = {
  class: "md:hidden",
  style: {"height":"calc(100vh - 177px)"}
}
const _hoisted_12 = { class: "custom-title flex flex-col" }
const _hoisted_13 = { class: "ml-auto" }
const _hoisted_14 = { class: "flex items-center space-x-1" }
const _hoisted_15 = { style: {"height":"calc(100vh - 227px)","overflow-y":"auto"} }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "flex flex-wrap gap-4 p-4"
}
const _hoisted_20 = { class: "absolute top-0 right-1.5 z-10" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { class: "flex flex-col justify-between" }
const _hoisted_23 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_24 = {
  class: "my-2 h-[160px]",
  align: "center"
}
const _hoisted_25 = {
  key: 1,
  class: "w-full h-full bg-gray-100"
}
const _hoisted_26 = { class: "flex justify-center" }
const _hoisted_27 = { class: "hidden md:block w-full" }
const _hoisted_28 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 1,
  style: {"height":"calc(100vh - 260px)"}
}
const _hoisted_31 = { style: {"overflow-y":"auto","height":"calc(100vh - 270px)"} }
const _hoisted_32 = { class: "flex flex-wrap gap-4 p-4" }
const _hoisted_33 = { class: "absolute top-0 right-1.5 z-10" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "h-[100px] flex flex-col justify-between" }
const _hoisted_36 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_37 = {
  class: "my-2 h-[160px]",
  align: "center"
}
const _hoisted_38 = {
  key: 1,
  class: "w-full h-full bg-gray-100"
}
const _hoisted_39 = { class: "flex justify-center" }
const _hoisted_40 = { class: "flex w-full justify-end mt-4" }
const _hoisted_41 = { class: "hidden md:block mr-3" }
const _hoisted_42 = { class: "md:hidden" }
const _hoisted_43 = { class: "flex flex-col md:flex-row" }
const _hoisted_44 = { class: "w-full md:w-1/3" }
const _hoisted_45 = { class: "relative" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "w-full md:w-2/3" }
const _hoisted_48 = { class: "flex flex-col gap-2" }
const _hoisted_49 = { class: "flex items-center gap-2 flex-wrap" }
const _hoisted_50 = { class: "flex flex-col w-full" }
const _hoisted_51 = {
  key: 0,
  class: "barcode-scanner-container"
}
const _hoisted_52 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrganizationSelect = _resolveComponent("OrganizationSelect")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_CategorySelect = _resolveComponent("CategorySelect")!
  const _component_AutoCompleteInput = _resolveComponent("AutoCompleteInput")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_Close = _resolveComponent("Close")!
  const _component_ImgLoading = _resolveComponent("ImgLoading")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_mian = _resolveComponent("el-mian")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_UploadFilled = _resolveComponent("UploadFilled")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_BarcodeScanner = _resolveComponent("BarcodeScanner")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, { style: {"height":"calc(100vh - 52px)"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, {
          style: {"height":"auto"},
          class: "bg-gray-200 p-3 md:p-5"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form, {
                  model: _ctx.searchForm,
                  "label-width": "auto",
                  "label-position": "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["grid gap-4", [
                                _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'md:grid-cols-4' : 'md:grid-cols-3',
                            ]])
                    }, [
                      _withDirectives(_createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "組織"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_OrganizationSelect, {
                            modelValue: _ctx.searchForm.organization_id,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.organization_id) = $event)),
                            "is-search": true,
                            placeholder: "組織を選択"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM]
                      ]),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "カテゴリ"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_CategorySelect, {
                            "organization-id": _ctx.searchForm.organization_id,
                            "is-search": true,
                            modelValue: _ctx.searchForm.category_id,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.category_id) = $event)),
                            placeholder: "カテゴリを選択"
                          }, null, 8, ["organization-id", "modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "アイテム名"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_AutoCompleteInput, {
                            modelValue: _ctx.searchForm.name,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchForm.name) = $event)),
                            placeholder: "アイテム名を入力",
                            "storage-key": "material-name-history",
                            "max-history-items": 15,
                            ref: "materialNameInput"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_el_button, {
                          class: "hidden md:block w-24",
                          type: "info",
                          onClick: _ctx.handleSearchButton
                        }, {
                          default: _withCtx(() => _cache[38] || (_cache[38] = [
                            _createTextVNode("検索")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _createVNode(_component_el_drawer, {
                class: "md:hidden bg-gray-200",
                modelValue: _ctx.drawer,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.drawer) = $event)),
                title: "検索",
                direction: "ttb",
                "with-header": false,
                size: "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_form, {
                      model: _ctx.searchForm,
                      "label-width": "auto",
                      "label-position": "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _withDirectives(_createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "組織"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_OrganizationSelect, {
                                modelValue: _ctx.searchForm.organization_id,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchForm.organization_id) = $event)),
                                "is-search": true,
                                placeholder: "組織を選択"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM]
                          ]),
                          _createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "カテゴリ"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_CategorySelect, {
                                "organization-id": _ctx.searchForm.organization_id,
                                "is-search": true,
                                modelValue: _ctx.searchForm.category_id,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchForm.category_id) = $event)),
                                placeholder: "カテゴリを選択"
                              }, null, 8, ["organization-id", "modelValue"])
                            ]),
                            _: 1
                          }),
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_el_form_item, {
                              class: "no-margin flex-grow",
                              label: "アイテム名"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_AutoCompleteInput, {
                                  modelValue: _ctx.searchForm.name,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchForm.name) = $event)),
                                  placeholder: "アイテム名を入力",
                                  "storage-key": "material-name-history",
                                  "max-history-items": 15,
                                  ref: "materialNameInput"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_el_button, {
                                class: "md:hidden ml-3",
                                type: "info",
                                onClick: _ctx.handleSearchButton,
                                circle: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => _cache[39] || (_cache[39] = [
                                      _createElementVNode("span", { class: "material-symbols-outlined" }, "manage_search", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (!_ctx.isGrid)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.updateGridMode(true))),
                        circle: ""
                      }, {
                        default: _withCtx(() => _cache[40] || (_cache[40] = [
                          _createElementVNode("span", { class: "material-symbols-outlined" }, " lists ", -1)
                        ])),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.updateGridMode(false))),
                        circle: ""
                      }, {
                        default: _withCtx(() => _cache[41] || (_cache[41] = [
                          _createElementVNode("span", { class: "material-symbols-outlined" }, " grid_view ", -1)
                        ])),
                        _: 1
                      }))
                ]),
                _createVNode(_component_el_button, {
                  class: "custom-icon-btn md:hidden",
                  type: "info",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.drawer = true)),
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[42] || (_cache[42] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, " manage_search ", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  class: "custom-icon-btn md:hidden",
                  type: "info",
                  onClick: _ctx.handleAddButton,
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[43] || (_cache[43] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, " add ", -1)
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, {
                  class: "hidden md:block w-24",
                  type: "info",
                  onClick: _ctx.handleAddButton
                }, {
                  default: _withCtx(() => _cache[44] || (_cache[44] = [
                    _createTextVNode("新規登録")
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead))
                  ? (_openBlock(), _createBlock(_component_el_upload, {
                      key: 0,
                      class: "",
                      ref: "upload",
                      "on-change": _ctx.handleImportButton,
                      "auto-upload": false,
                      "show-file-list": false,
                      accept: ".csv"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          content: "CSVインポート",
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              class: "custom-icon-btn mx-3",
                              type: "info",
                              circle: ""
                            }, {
                              default: _withCtx(() => _cache[45] || (_cache[45] = [
                                _createElementVNode("span", { class: "material-symbols-outlined" }, " upload_2 ", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["on-change"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  class: "custom-icon-btn",
                  type: "info",
                  onClick: _ctx.handleExportButton,
                  circle: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tooltip, {
                      content: "CSVエクスポート",
                      placement: "top"
                    }, {
                      default: _withCtx(() => _cache[46] || (_cache[46] = [
                        _createElementVNode("span", { class: "material-symbols-outlined" }, " download_2 ", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createElementVNode("div", _hoisted_10, [
                  (!_ctx.isGrid)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        class: "w-12",
                        style: {"background-color":"#ffffff"},
                        text: "",
                        bg: "",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.updateGridMode(true)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => _cache[47] || (_cache[47] = [
                              _createElementVNode("span", { class: "material-symbols-outlined mt-1" }, "lists", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        class: "w-12 hidden md:block",
                        style: {"background-color":"#ffffff"},
                        text: "",
                        bg: "",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.updateGridMode(false)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => _cache[48] || (_cache[48] = [
                              _createElementVNode("span", { class: "material-symbols-outlined mt-1" }, "grid_view", -1)
                            ])),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_mian, { style: {"padding-bottom":"20px"} }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _cache[53] || (_cache[53] = _createElementVNode("span", null, "アイテムマスタ（品名　カテゴリ　JANコード）", -1)),
                _createElementVNode("span", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _cache[52] || (_cache[52] = _createElementVNode("span", { class: "text-white" }, "ソート:", -1)),
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleSort('name'))),
                      class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'name' ? 'active' : ''])
                    }, {
                      default: _withCtx(() => _cache[49] || (_cache[49] = [
                        _createTextVNode(" アイテム名 ")
                      ])),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleSort('category_name'))),
                      class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'category_name' ? 'active' : ''])
                    }, {
                      default: _withCtx(() => _cache[50] || (_cache[50] = [
                        _createTextVNode(" カテゴリ ")
                      ])),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleSort('jancode'))),
                      class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'jancode' ? 'active' : ''])
                    }, {
                      default: _withCtx(() => _cache[51] || (_cache[51] = [
                        _createTextVNode(" JANコード ")
                      ])),
                      _: 1
                    }, 8, ["class"]),
                    _createElementVNode("span", null, "アイテム数: " + _toDisplayString(_ctx.mTotalRecords), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                (!_ctx.isGrid)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.mTableData, (item) => {
                      return (_openBlock(), _createBlock(_component_el_card, {
                        style: {"border":"1px solid #d1d5db","border-radius":"0px"},
                        key: item.material_code
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_row, { align: "middle" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, { span: 2 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_button, {
                                    class: "w-8 h-16",
                                    type: "info",
                                    style: {"background-color":"#b7b7b7"},
                                    text: "",
                                    bg: "",
                                    onClick: ($event: any) => (_ctx.handleEditButton(item))
                                  }, {
                                    default: _withCtx(() => _cache[54] || (_cache[54] = [
                                      _createElementVNode("span", null, [
                                        _createTextVNode("詳"),
                                        _createElementVNode("br"),
                                        _createTextVNode("細")
                                      ], -1)
                                    ])),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, {
                                span: 18,
                                class: "ml-2"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(item.organization_name), 1))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("div", null, _toDisplayString(item.name), 1),
                                  _createVNode(_component_el_row, { justify: "space-between" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", null, _toDisplayString(item.category_name), 1),
                                      _createElementVNode("div", null, _toDisplayString(item.jancode), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  (item.unit)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, "単位: " + _toDisplayString(item.unit), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_col, {
                                span: 2,
                                class: "ml-2",
                                align: "right"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    class: "material-symbols-outlined cursor-pointer",
                                    onClick: ($event: any) => (_ctx.handleDeleteButton(item))
                                  }, " delete ", 8, _hoisted_18)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mTableData, (item) => {
                        return (_openBlock(), _createBlock(_component_el_card, {
                          style: {"width":"100%","border":"2px solid #d1d5db","border-radius":"10px","position":"relative"},
                          key: item.material_code
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_el_button, {
                                link: "",
                                onClick: ($event: any) => (_ctx.handleDeleteButton(item))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Close)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(item.organization_name), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("div", null, _toDisplayString(item.name), 1),
                              _createVNode(_component_el_row, { justify: "space-between" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, _toDisplayString(item.category_name), 1),
                                  _createElementVNode("div", null, _toDisplayString(item.jancode), 1)
                                ]),
                                _: 2
                              }, 1024),
                              (item.unit)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, "単位: " + _toDisplayString(item.unit), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_24, [
                              (item.images)
                                ? (_openBlock(), _createBlock(_component_ImgLoading, {
                                    key: 0,
                                    modelValue: item.images,
                                    "onUpdate:modelValue": ($event: any) => ((item.images) = $event),
                                    class: "carousel-image"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_25))
                            ]),
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_el_button, {
                                class: "w-12",
                                type: "info",
                                style: {"background-color":"#b7b7b7"},
                                text: "",
                                bg: "",
                                onClick: ($event: any) => (_ctx.handleEditButton(item))
                              }, {
                                default: _withCtx(() => _cache[55] || (_cache[55] = [
                                  _createElementVNode("span", null, "詳細", -1)
                                ])),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]))
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_27, [
              (!_ctx.isGrid)
                ? _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                    key: 0,
                    data: _ctx.mTableData,
                    height: "calc(100vh - 260px)"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        label: "アイテムマスタ",
                        width: "130",
                        align: "center"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_button, {
                            class: "w-12",
                            type: "info",
                            style: {"background-color":"#b7b7b7"},
                            text: "",
                            bg: "",
                            onClick: ($event: any) => (_ctx.handleEditButton(scope.row))
                          }, {
                            default: _withCtx(() => _cache[56] || (_cache[56] = [
                              _createElementVNode("span", null, "詳細", -1)
                            ])),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 1
                      }),
                      (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                        ? (_openBlock(), _createBlock(_component_el_table_column, {
                            key: 0,
                            prop: "organization_name",
                            label: "所属組織",
                            width: "160"
                          }, {
                            header: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "flex items-center cursor-pointer whitespace-nowrap",
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleSort('organization_name')))
                              }, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('organization_name')), 1),
                                _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", {
                                      class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'organization_name' }])
                                    }, _toDisplayString(_ctx.getSortIcon('organization_name')), 3)
                                  ]),
                                  _: 1
                                })
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_el_table_column, {
                        prop: "category_name",
                        label: "カテゴリ",
                        width: "160"
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "flex items-center cursor-pointer whitespace-nowrap",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleSort('category_name')))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('category_name')), 1),
                            _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'category_name' }])
                                }, _toDisplayString(_ctx.getSortIcon('category_name')), 3)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "name",
                        label: "品名",
                        "min-width": "400"
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "flex items-center cursor-pointer whitespace-nowrap",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handleSort('name')))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('name')), 1),
                            _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'name' }])
                                }, _toDisplayString(_ctx.getSortIcon('name')), 3)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.name), 1),
                          _cache[57] || (_cache[57] = _createElementVNode("br", null, null, -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "jancode",
                        label: "JANコード",
                        "min-width": "100"
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "flex items-center cursor-pointer whitespace-nowrap",
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.handleSort('jancode')))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('jancode')), 1),
                            _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'jancode' }])
                                }, _toDisplayString(_ctx.getSortIcon('jancode')), 3)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        default: _withCtx((scope) => [
                          (scope.row.jancode)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(scope.row.jancode), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "maker",
                        label: "メーカー",
                        width: "280"
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "flex items-center cursor-pointer whitespace-nowrap",
                            onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.handleSort('maker')))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('maker')), 1),
                            _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'maker' }])
                                }, _toDisplayString(_ctx.getSortIcon('maker')), 3)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "expiration_day",
                        label: "初期期限",
                        width: "100",
                        "header-align": "center",
                        align: "right"
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "flex items-center cursor-pointer whitespace-nowrap",
                            onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.handleSort('expiration_day')))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('expiration_day')), 1),
                            _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'expiration_day' }])
                                }, _toDisplayString(_ctx.getSortIcon('expiration_day')), 3)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        default: _withCtx(({ row }) => [
                          _createTextVNode(_toDisplayString(row.expiration_day + "日"), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "unit",
                        label: "単位",
                        width: "100",
                        align: "center"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "",
                        label: "画像",
                        width: "52",
                        align: "center"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_ImgLoading, {
                            modelValue: scope.row.images,
                            "onUpdate:modelValue": ($event: any) => ((scope.row.images) = $event),
                            class: "thumbnail"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        label: "削除",
                        width: "52",
                        align: "center"
                      }, {
                        default: _withCtx((scope) => [
                          _createElementVNode("span", {
                            class: "material-symbols-outlined cursor-pointer mt-2",
                            onClick: ($event: any) => (_ctx.handleDeleteButton(scope.row))
                          }, " delete ", 8, _hoisted_29)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"])), [
                    [_directive_loading, _ctx.loading]
                  ])
                : _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _cache[59] || (_cache[59] = _createElementVNode("div", {
                      class: "custom-title flex items-center",
                      style: {"height":"40px"}
                    }, [
                      _createElementVNode("span", null, "アイテムマスタ（品名　カテゴリ　JANコード）"),
                      _createElementVNode("span")
                    ], -1)),
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mTableData, (item) => {
                          return (_openBlock(), _createBlock(_component_el_card, {
                            style: {"width":"250px","border":"2px solid #d1d5db","border-radius":"10px","position":"relative"},
                            key: item.material_code
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_33, [
                                _createVNode(_component_el_button, {
                                  link: "",
                                  onClick: ($event: any) => (_ctx.handleDeleteButton(item))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Close)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"])
                              ]),
                              (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, _toDisplayString(item.organization_name), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_35, [
                                _createElementVNode("div", null, _toDisplayString(item.name), 1),
                                _createVNode(_component_el_row, { justify: "space-between" }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, _toDisplayString(item.category_name), 1),
                                    _createElementVNode("div", null, _toDisplayString(item.jancode), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                (item.unit)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, "単位: " + _toDisplayString(item.unit), 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_37, [
                                (item.images)
                                  ? (_openBlock(), _createBlock(_component_ImgLoading, {
                                      key: 0,
                                      modelValue: item.images,
                                      "onUpdate:modelValue": ($event: any) => ((item.images) = $event),
                                      class: "carousel-image"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_38))
                              ]),
                              _createElementVNode("div", _hoisted_39, [
                                _createVNode(_component_el_button, {
                                  class: "w-12",
                                  type: "info",
                                  style: {"background-color":"#b7b7b7"},
                                  text: "",
                                  bg: "",
                                  onClick: ($event: any) => (_ctx.handleEditButton(item))
                                }, {
                                  default: _withCtx(() => _cache[58] || (_cache[58] = [
                                    _createElementVNode("span", null, "詳細", -1)
                                  ])),
                                  _: 2
                                }, 1032, ["onClick"])
                              ])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ])
                    ])
                  ])), [
                    [_directive_loading, _ctx.loading]
                  ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("div", _hoisted_41, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.mCurrentPage,
                  "onUpdate:currentPage": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.mCurrentPage) = $event)),
                  "page-size": _ctx.mPageSize,
                  "onUpdate:pageSize": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.mPageSize) = $event)),
                  "page-sizes": [10, 20, 50, 100],
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _ctx.mTotalRecords,
                  onSizeChange: _ctx.handleSizeChange,
                  onCurrentChange: _ctx.handlePageChange
                }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createVNode(_component_el_pagination, {
                  layout: "prev, pager, next",
                  total: _ctx.mTotalRecords,
                  onCurrentChange: _ctx.handlePageChange
                }, null, 8, ["total", "onCurrentChange"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      style: {"max-width":"800px"},
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      title: _ctx.form.add_update === 'add' ? '新規登録' : '詳細',
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_52, [
          _createVNode(_component_el_button, {
            onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withCtx(() => _cache[66] || (_cache[66] = [
              _createTextVNode("キャンセル")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.handleAddUpdateSubmit(_ctx.formRef)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.form.add_update === 'add' ? '登録' : '更新'), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_43, [
          _createElementVNode("div", _hoisted_44, [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createVNode(_component_el_upload, {
                class: "p-2",
                drag: "",
                action: "#",
                "auto-upload": false,
                "on-change": _ctx.handleImageChange,
                "show-file-list": false,
                accept: ".jpg,.jpeg,.png,.webp,.gif"
              }, {
                default: _withCtx(() => [
                  (_ctx.imageUrl)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.imageUrl,
                        class: "w-full h-fill object-cover"
                      }, null, 8, _hoisted_46))
                    : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_UploadFilled)
                        ]),
                        _: 1
                      })),
                  _cache[60] || (_cache[60] = _createElementVNode("div", { class: "el-upload__text" }, [
                    _createTextVNode(" ドラッグ＆ドロップまたは "),
                    _createElementVNode("em", null, "クリック"),
                    _createTextVNode(" して画像をアップロード ")
                  ], -1))
                ]),
                _: 1
              }, 8, ["on-change"])
            ])), [
              [_directive_loading, _ctx.imageLoading]
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_el_form, {
              model: _ctx.form,
              rules: _ctx.rules,
              ref: "formRef",
              "label-width": "100px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "コード",
                  prop: "material_code",
                  hidden: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.material_code,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.material_code) = $event)),
                      autocomplete: "off",
                      disabled: _ctx.form.add_update === 'update',
                      placeholder: "コード"
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "アイテム名",
                  prop: "name"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.name,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.name) = $event)),
                      autocomplete: "off",
                      placeholder: "アイテム名"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "JANコード",
                  prop: "jancode",
                  error: _ctx.errors.jancode
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.jancode,
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.jancode) = $event)),
                      autocomplete: "off",
                      placeholder: "JANコード"
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          style: {"background-color":"rgb(76, 175, 80)","color":"white","border":"none","height":"100%","margin":"0","padding":"0 8px","border-right":"1px solid #dcdfe6"},
                          onClick: _ctx.handleScanStart
                        }, {
                          default: _withCtx(() => _cache[61] || (_cache[61] = [
                            _createTextVNode(" スキャンを開始")
                          ])),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_el_button, {
                          style: {"background-color":"rgb(21, 96, 130)","color":"white","border":"none","height":"100%","margin":"0","padding":"0 8px","border-radius":"0 4px 4px 0"},
                          onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.handleJancodeSearch(_ctx.form.jancode)))
                        }, {
                          default: _withCtx(() => _cache[62] || (_cache[62] = [
                            _createTextVNode("検索")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["error"]),
                (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "所属組織",
                      prop: "organization_id"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_OrganizationSelect, {
                          modelValue: _ctx.form.organization_id,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.organization_id) = $event)),
                          placeholder: "組織を選択",
                          disabled: _ctx.form.add_update === 'update'
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  label: "カテゴリ",
                  prop: "category_id"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CategorySelect, {
                      "organization-id": _ctx.form.organization_id,
                      modelValue: _ctx.form.category_id,
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.form.category_id) = $event)),
                      placeholder: "カテゴリを選択"
                    }, null, 8, ["organization-id", "modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "メーカー" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.maker,
                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.form.maker) = $event)),
                      autocomplete: "off",
                      placeholder: "メーカー"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "詳細" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.form.description,
                      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.form.description) = $event)),
                      type: "textarea",
                      rows: 3,
                      autocomplete: "off",
                      placeholder: "サイズ: ？cm x ？cm x ？cm, 内容物: ？,容量: ？, 色: ？, 包装: ？　など"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { label: "初期期限" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: _ctx.expiryMode,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.expiryMode) = $event)),
                      onChange: _ctx.handleExpiryModeChange
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_48, [
                          _createElementVNode("div", _hoisted_49, [
                            _createVNode(_component_el_radio, { label: "days" }, {
                              default: _withCtx(() => _cache[63] || (_cache[63] = [
                                _createTextVNode("有効期限")
                              ])),
                              _: 1
                            }),
                            (_ctx.expiryMode === 'days')
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_el_input_number, {
                                    modelValue: _ctx.form.expiration_day,
                                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.form.expiration_day) = $event)),
                                    min: 0,
                                    max: _ctx.NO_EXPIRY_DAY - 1,
                                    placeholder: "初期期限"
                                  }, null, 8, ["modelValue", "max"]),
                                  _cache[64] || (_cache[64] = _createElementVNode("span", null, "日", -1))
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode(_component_el_radio, { label: "none" }, {
                            default: _withCtx(() => _cache[65] || (_cache[65] = [
                              _createTextVNode("無期限")
                            ])),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "単位",
                  prop: "unit"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.form.unit,
                      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.form.unit) = $event)),
                      placeholder: "単位を選択",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: "個",
                          value: "個"
                        }),
                        _createVNode(_component_el_option, {
                          label: "箱",
                          value: "箱"
                        }),
                        _createVNode(_component_el_option, {
                          label: "枚",
                          value: "枚"
                        }),
                        _createVNode(_component_el_option, {
                          label: "本",
                          value: "本"
                        }),
                        _createVNode(_component_el_option, {
                          label: "セット",
                          value: "セット"
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ])
        ]),
        _createElementVNode("div", _hoisted_50, [
          (_ctx.barcodeScannerState)
            ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                _createVNode(_component_BarcodeScanner, {
                  ref: "barcodeScannerRef",
                  onCodeScanned: _ctx.handleJancodeSearch,
                  onScanStopped: _cache[34] || (_cache[34] = ($event: any) => (_ctx.barcodeScannerState = false))
                }, null, 8, ["onCodeScanned"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}